import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiStar, FiClock, FiArrowRight } from 'react-icons/fi';
import resolveImage from '../../utils/imageUrl';
import './ServiceCard.css';

const ServiceCard = ({ service }) => {
  const navigate = useNavigate();

  return (
    <article
      className="service-card card"
      onClick={() => navigate(`/services/${service.slug}`)}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/services/${service.slug}`)}
      aria-label={`Book ${service.name} — from ₹${service.basePrice}`}
    >
      {/* Image */}
      <div className="service-card-img">
        {service.image
          ? <img
              src={resolveImage(service.image)}
              alt={`${service.name} service in Kolkata`}
              loading="lazy"
              width="320"
              height="200"
            />
          : <div className="service-card-img-placeholder" aria-hidden="true">🧹</div>
        }
        {service.isFeatured && <span className="featured-badge">Popular</span>}
      </div>

      {/* Body */}
      <div className="service-card-body">
        <div className="service-card-meta">
          {service.categoryId?.name && (
            <span className="service-category">{service.categoryId.name}</span>
          )}
          {service.averageRating > 0 && (
            <span className="service-rating" aria-label={`Rated ${service.averageRating.toFixed(1)} out of 5`}>
              <FiStar size={11} aria-hidden="true" />
              {service.averageRating.toFixed(1)}
              <span className="rating-count">({service.totalReviews})</span>
            </span>
          )}
        </div>

        <h3 className="service-name">{service.name}</h3>

        {service.shortDescription && (
          <p className="service-desc">{service.shortDescription}</p>
        )}

        {service.duration && (
          <span className="service-duration">
            <FiClock size={11} aria-hidden="true" /> ~{service.duration} min
          </span>
        )}
      </div>

      {/* Footer — always at bottom, never cut off */}
      <div className="service-card-footer">
        <div className="service-price" itemScope itemType="https://schema.org/Offer">
          <span className="price-label">
            {service.priceUnit === 'fixed' ? '' : 'From'}
          </span>
          <span className="price-value" itemProp="price" content={service.basePrice}>
            ₹{service.basePrice}
          </span>
          <meta itemProp="priceCurrency" content="INR" />
        </div>
        <button className="book-now-btn" aria-label={`Book ${service.name} now`}>
          Book Now <FiArrowRight size={13} aria-hidden="true" />
        </button>
      </div>
    </article>
  );
};

export default ServiceCard;
